<template>
    <AppSection :title="params.messages.title" class="clients-section" :b_bottom="params.b_bottom">
        <template #header_left v-if="params.header_left">
            <div v-html="params.header_left"></div>
        </template>
        <template #header_right v-if="params.header_right">
            <a v-if="params.header_right.link" :href="params.header_right.link">{{params.header_right.title}}</a>
        </template>
        <template #body>
            <slider-cards
                :params="{
                    slidesPerView: 3,
                    breakpoints: {
                        320: {
                            slidesPerView: 1.2,
                            spaceBetween: 20,
                        },
                        600: {
                            slidesPerView: 2.2,
                            spaceBetween: 20,
                        },
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 30,
                        }
                    },
                }"
            >
                <swiper-slide v-for="(item, i) in params.items" :key="i">
                    <client-card v-bind="item"/>
                </swiper-slide>
            </slider-cards>
        </template>
    </AppSection>
</template>

<script>
import AppSection from '../AppSection.vue'
import ClientCard from '../cards/ClientCard.vue'
import SliderCards from '../SliderCards.vue'
import { SwiperSlide } from 'swiper/vue';

export default {
    name: 'ClientsSection',
    props: {
        params: {
            type: Object,
            default: () => {}
        }
    },
    components: {
        AppSection,
        ClientCard,
        SliderCards,
        SwiperSlide,
    },
    setup: (props, ctx) => {
        
        return {

        }
    },
}
</script>

<style lang="scss">
    .clients-section {
        .swiper {
            overflow: initial;

            @include tablet {
                overflow: hidden;
                padding: 30px 15px;
                margin: -30px -15px;
            }
        }
    }
</style>
